"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "4.0.47";



//////////////////
// WEBPACK FOOTER
// ./~/ethers/_version.js
// module id = rjLA
// module chunks = 0